import {errorMessages} from './errorMessages';
import {parseError} from './parseError';

export const getErrorMessage = (error: unknown): string => {
  const {errorCode} = parseError(error);
  return errorMessages[errorCode];
};
